import OfferKOCritDetails from './OfferKOCritDetails';

export type { IOfferKOCritDetailsHandle } from './OfferKOCritDetails';
export default OfferKOCritDetails;
